var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculationActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5h-3v1h3v-1zM10.5 14.5h-1v-1h-1v1h-1v1h1v1h1v-1h1v-1zM10.5 8.5h-3v1h3v-1zM16.5 12.5h-3v1h3v-1z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.5h-11a1.001 1.001 0 0 0-1 1v11a1.001 1.001 0 0 0 1 1h11a1.002 1.002 0 0 0 1-1v-11a1.001 1.001 0 0 0-1-1zm-6 1v5h-5v-5h5zm-5 6h5v5h-5v-5zm6 5v-11h5v11h-5z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculationActiveIcon);
export default __webpack_public_path__ + "static/media/calculationActiveIcon.f8c25095f35f4d57783624e7bed7331e.svg";
export { ForwardRef as ReactComponent };